import { orange700, deepOrange700 } from 'material-ui/styles/colors'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: orange700,
    primary2Color: deepOrange700,
    pickerHeaderColor: orange700
  }
})

export default muiTheme



// WEBPACK FOOTER //
// ./src/style/colors.js